import styled from 'styled-components';

import media from '../../styles/media.style';
import { BG_GRAY, BLACK, PAGE_WIDTH } from '../../styles/variables.style';

export const Section = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: ${PAGE_WIDTH}px;
  padding: 40px 0;
  width: 100%;
`;

export const Title = styled.h5`
  position: relative;
  text-transform: uppercase;
  font-size: 16px;
  margin: 0 0 4em;
  text-align: center;
  color: ${BLACK};

  ${media.tabletL`
    margin-bottom: 5em;
  `};

  &::after {
    content: '';
    position: absolute;
    bottom: -18px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${BG_GRAY.COMMON_8};
    height: 3px;
    width: 40px;
  }
`;

export const ReviewsContainer = styled.div`
  width: 100%;
  margin-bottom: 4em;
`;

export const SlideWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${media.tabletL`
    flex-direction: row;
  `};
`;

export const ImageWrapper = styled.div`
  flex: 1;
  background-color: #000;
`;

export const QuoteWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #000;
  color: #fff;
  height: 30em;

  ${media.tabletL`
    height: ${({ height }) => height};
  `};
`;

export const ContentText = styled.p`
  line-height: 37px;
  font-size: 28px;
  letter-spacing: 1px;
  text-align: center;
  max-width: 450px;
  margin: 0 auto;
  width: 90%;

  ${media.tabletL`
    font-style: italic;
    font-size: 32px;
    line-height: 42px;
  `};
`;

export const AuthorText = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  text-align: center;
  margin-top: 1em;
  max-width: 450px;
  width: 90%;

  ${media.tabletL`
    font-size: 18px;
    line-height: 24px;
    margin-top: 2em;
  `};
`;

export const AuthorName = styled.p`
  text-transform: uppercase;
  margin: 0;
`;



// WEBPACK FOOTER //
// ./src/components/ProductReviews/ProductReviews.style.js